// src/Components/Header.jsx
import React, { useState } from "react";
import {
  AppBar,
  CssBaseline,
  Toolbar,
  useScrollTrigger,
  Grid,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import { PropTypes } from "prop-types";
import { useLocation, Link } from "react-router-dom";
import { COLORS, size } from "../utils";
import styles from "./Header.module.css";
import { FiMenu } from "react-icons/fi";

function ElevationScroll(props) {
  const { children, trigger } = props;
  return React.cloneElement(children, {
    sx: {
      backgroundColor: "transparent",
      pt: size({ p: 0.5, h: true }),
      pb: size({ p: 0.5, h: true }),
    },
    elevation: trigger ? 0 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
};

export default function Header(props) {
  const { window, menus = [] } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };
  

  return (
    <ElevationScroll {...props} trigger={trigger}>
      <AppBar
        position="sticky"
        style={{ background: COLORS.C1, backdropFilter: "blur(12px)" }}
      >
        <CssBaseline />
        <Toolbar>
          <Grid
            container
            flexWrap={"nowrap"}
            md
            alignItems={"center"}
            justifyContent={"space-evenly"}
            className={styles["header-container"]}
          >
            <Link
              to="/"
              style={{
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              <Grid
                item
                container
                flexWrap={"nowrap"}
                alignItems={"center"}
                columnGap={size({ p: 0.3 })}
                className={styles["header-logo"]}
              >
                <Grid item>
                  <CardMedia
                    className={styles["header-logo-1"]}
                    component={"img"}
                    image={"/assets/images/logo.jpg"}
                    sx={{
                      width: '100%',
                      height: size({ p: 2.8 }),
                    }}
                  />
                </Grid>
                {/* <Grid item>
                  <Typography
                    className={styles["header-logo-2"]}
                    style={{
                      fontFamily: "Archia",
                      fontWeight: 600,
                      fontSize: size({ p: 1.8 }),
                      color: COLORS.WHITE,
                      textTransform: "capitalize",
                      paddingBottom: size({ p: 0.6, h: true }),
                    }}
                  >
                    genesys academy
                  </Typography>
                </Grid> */}
              </Grid>
            </Link>

            {/* Desktop Menu */}
            <Grid
              item
              display={"flex"}
              flexWrap={"nowrap"}
              columnGap={size({ p: 0.5 })}
              className={styles["header-old-menu"]}
            >
              {menus.map((menu, index) => {
                const isExternal = !!menu.external; // For future use if needed
                const isButton = !!menu.button;

                if (isButton) {
                  return (
                    <Grid item key={index}>
                      <Button
                        href={menu.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          color: COLORS.WHITE,
                          fontSize: size({ p: 0.9 }),
                          padding: `${size({ p: 0.5, h: true })} ${size({
                            p: 1.5,
                          })}`,
                          borderRadius: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          marginTop: "-2.5px",
                          "&:hover": {
                            backgroundColor: COLORS.C3,
                            boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
                          },
                        }}
                      >
                        {menu.name}
                      </Button>
                    </Grid>
                  );
                }

                return isExternal ? (
                  <Grid item key={index}>
                    <a
                      href={menu.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={handleCloseMenu}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Archia",
                          fontWeight: 600,
                          fontSize: size({ p: 0.9 }),
                          color: COLORS.WHITE,
                          padding: `${size({ p: 0.5, h: true })} ${size({
                            p: 0.8,
                          })}`,
                          borderRadius: size({ p: 2 }),
                          backgroundColor:
                            location.pathname === menu.path ? COLORS.C3 + "A0" : "transparent",
                          "&:hover": {
                            backgroundColor: COLORS.C3,
                          },
                        }}
                      >
                        {menu.name}
                      </Typography>
                    </a>
                  </Grid>
                ) : (
                  <Grid item key={index}>
                    <Link
                      to={menu.path}
                      onClick={handleCloseMenu}
                      style={{ textDecoration: "none", cursor: "pointer" }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Archia",
                          fontWeight: 600,
                          fontSize: size({ p: 0.9 }),
                          color: COLORS.WHITE,
                          padding: `${size({ p: 0.5, h: true })} ${size({
                            p: 0.8,
                          })}`,
                          borderRadius: size({ p: 2 }),
                          backgroundColor:
                            location.pathname === menu.path ? COLORS.C3 + "A0" : "transparent",
                          "&:hover": {
                            backgroundColor: COLORS.C3,
                          },
                        }}
                      >
                        {menu.name}
                      </Typography>
                    </Link>
                  </Grid>
                );
              })}
            </Grid>

            {/* Mobile Menu Icon */}
            <Grid className={styles["menu"]} onClick={handleToggleMenu}>
              <FiMenu />
            </Grid>
          </Grid>
        </Toolbar>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <Grid container direction="column" className={styles["mobile-menu"]}>
            {menus.map((menu, index) => {
              const isExternal = !!menu.external;
              const isButton = !!menu.button;

              if (isButton) {
                return (
                  <a
                    key={index}
                    href={menu.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", width: "100%" }}
                    onClick={handleCloseMenu}
                  >
                    <Typography
                      style={{
                        fontFamily: "Archia",
                        fontWeight: 500,
                        fontSize: size({ p: 2.6 }),
                        color: COLORS.WHITE,
                        padding: size({ p: 3 }),
                        backgroundColor: COLORS.C1,
                        textAlign: "center",
                      }}
                    >
                      {menu.name}
                    </Typography>
                  </a>
                );
              }

              return isExternal ? (
                <a
                  key={index}
                  href={menu.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", width: "100%" }}
                  onClick={handleCloseMenu}
                >
                  <Typography
                    style={{
                      fontFamily: "Archia",
                      fontWeight: 500,
                      fontSize: size({ p: 2.6 }),
                      color: COLORS.WHITE,
                      padding: size({ p: 3 }),
                      backgroundColor: COLORS.C1,
                      textAlign: "center",
                    }}
                  >
                    {menu.name}
                  </Typography>
                </a>
              ) : (
                <Link
                  key={index}
                  to={menu.path}
                  onClick={handleCloseMenu}
                  style={{ textDecoration: "none", width: "100%" }}
                >
                  <Typography
                    style={{
                      fontFamily: "Archia",
                      fontWeight: 500,
                      fontSize: size({ p: 2.6 }),
                      color: COLORS.WHITE,
                      padding: size({ p: 3 }),
                      backgroundColor:
                        location.pathname === menu.path ? COLORS.C3 + "A0" : COLORS.C1,
                      textAlign: "center",
                    }}
                  >
                    {menu.name}
                  </Typography>
                </Link>
              );
            })}
          </Grid>
        )}
      </AppBar>
    </ElevationScroll>
  );
}
